/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";

import Button from "@material-ui/core/Button";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";
import NoPhonePatientsDependants from "./NoPhonePatientDependants";
import DocumentScanner from "../../components/DocumentScanner";
import FileUploader from "components/FileUploader";
export default function NoPhonePatients() {
  const { api } = useContext(FirebaseContext);
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    updateUserConsentform,
  } = api;
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [SelectedUserData, SetSelectedUserData] = useState({});
  const [camStop, setCamStop] = React.useState(false);
  const [dataUri, setDataUri] = useState("");
  const [data, setData] = useState([]);
  const [practices, setPractices] = useState({});
  const usersdata = useSelector((state) => state.usersdata);
  const practicetypes = useSelector((state) => state.practicetypes);
  const auth = useSelector((state) => state.auth);
  const [openFPModal, setOpenFPModal] = React.useState(false);
  const [openFPModal1, setOpenFPModal1] = React.useState(false);
  const dispatch = useDispatch();
  const locales = {
    "en-US": require("date-fns/locale/en-US"),
  };

  const handleCloseEvent = () => {
    setOpenFPModal(false);
  };
  const handleCloseAndUploadEvent = () => {
    if (dataUri) {
      console.log("i am the selected userdata", SelectedUserData, dataUri);
      dispatch(updateUserConsentform(SelectedUserData.id, dataUri));
    }

    setOpenFPModal1(false);
  };

  useEffect(() => {
    console.log("i am the auth", auth);
    console.log("i am the users", usersdata.users);
    console.log("first", auth.info.profile.practiceNumber);
    if (usersdata.users) {
      setData(
        usersdata.users.filter(
          (user) =>
            (user.userType === "nophonepatient" || user.userType === "patient") &&
            user.practiceNumber === auth.info.profile.practiceNumber
        )
      );
    } else {
      setData(usersdata.users);
    }
  }, [usersdata.users, auth.info.profile.userType, auth.info.uid]);

  useEffect(() => {
    if (practicetypes.practices) {
      let obj = {};
      practicetypes.practices.map(
        (practice) => (obj[practice.name] = practice.name)
      );
      setPractices(obj);
    }
  }, [practicetypes.practices]);

const columns = [
  {
    header: 'First Name',
    accessorKey: 'firstName',
  },
  {
    header: 'Last Name',
    accessorKey: 'lastName',
  },
  {
    header: 'Email',
    accessorKey: 'email',
  },
  {
    header: 'Mobile',
    accessorKey: 'mobile',
  },
  {
    header: 'Identification Number',
    accessorKey: 'identityNumber',
  },
  {
    header: 'Gender',
    accessorKey: 'gender',
  },
  {
    header: 'Age',
    accessorKey: 'age',
  },
  {
    header: 'Relationship',
    accessorKey: 'relationship',
  },
  {
    header: 'Approved',
    accessorKey: 'approved',
    enableColumnFilter: false,
    enableSorting: true,
  },
  {
    header: 'Signup Via Referral',
    accessorKey: 'signupViaReferral',
  },

    {
    header: 'Consent Form',
    accessorKey: 'consentForm'
  },
];


  

 const onRowAdd= (newData) =>{
            new Promise((resolve, reject) => {
              setTimeout(() => {
                checkUserExists(newData).then((res) => {
                  if (res.users && res.users.length > 0) {
                    alert(language.user_exists);
                    reject();
                  } else if (res.error) {
                    alert(language.email_or_mobile_issue);
                    reject();
                  } else {
                    newData["createdByAdmin"] = true;
                    newData["userType"] = "nophonepatient";
                    newData["createdAt"] = new Date().toISOString();
                    newData["referralId"] =
                      newData.firstName.toLowerCase() +
                      Math.floor(1000 + Math.random() * 9000).toString();
                    let role = auth.info.profile.userType;
                    if (role === "practiceadmin") {
                      newData["practiceadmin"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "nurse") {
                      newData["nurse"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "doctor") {
                      newData["doctor"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    }
                    dispatch(addUser(newData));
                    resolve();
                  }
                });
              }, 600);
            })};


  const     onRowUpdate= (newData, oldData) =>{
            new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                dispatch(editUser(oldData.id, newData));
              }, 600);
            })
          };


  const   onRowDelete= (oldData) =>{
            features.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(deleteUser(oldData.id));
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(language.demo_mode);
                  }, 600);
                })
      };


  return usersdata.loading ? (
    <CircularLoading />
  ) : (
   <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { consentForm   : false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
  );
}
